module.exports = __webpack_public_path__ + "static/media/ico-overcast.8f2d604b.svg";